module.exports = __webpack_public_path__ + "img/20191219144611740.4de1093f.jpg";